export default __webpack_public_path__ + "static/media/dsyCaseStudy.957248d2.png";